import { useEffect, useState } from 'react'

import { useAppDispatch } from '@hooks'
import { showSnackbarNotification } from '@helpers'

const LS_BAR_CHART_CONFIG = 'bar_chart_config'

export const useScriptEditorConfig = () => {
  const dispatch = useAppDispatch()

  const [editorValue, setEditorValue] = useState<string>(
    '{"entityCode": "entityCode", "entityId": 0}'
  )

  const [barChartConfig, setBarChartConfig] = useState<Record<string, any>>({})

  useEffect(() => {
    const storageConfig = localStorage.getItem(LS_BAR_CHART_CONFIG)
    if (!storageConfig) {
      return
    }

    try {
      const config: Record<string, any> = JSON.parse(storageConfig)
      setEditorValue(JSON.stringify(config))
      setBarChartConfig(config)
    } catch {
      localStorage.removeItem(LS_BAR_CHART_CONFIG)
    }
  }, [])

  const handleEditorValueChange = (config: string) => {
    return setEditorValue(config)
  }

  const handleEditorConfigSave = () => {
    if (!editorValue) {
      return
    }

    try {
      const config = JSON.parse(editorValue)
      setBarChartConfig(config)
      localStorage.setItem(LS_BAR_CHART_CONFIG, JSON.stringify(config, null, '\t'))

      showSnackbarNotification({
        text: 'Successfully Saved!',
        options: {
          variant: 'success',
        },
      })
    } catch (err) {
      showSnackbarNotification({
        text: err as string,
        options: {
          variant: 'error',
        },
      })
    }
  }

  return { editorValue, barChartConfig, handleEditorValueChange, handleEditorConfigSave }
}
